import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT, BEST_XP_KEY } from '../config';
import QuestScene from './QuestScene';
import LineRiderScene from './LineRiderScene';

export const MENU_SCENE_KEY = 'Menu';

export default class MenuScene extends Phaser.Scene {
  static readonly key = MENU_SCENE_KEY;

  constructor() {
    super(MENU_SCENE_KEY);
  }

  create(): void {
    const cx = GAME_WIDTH / 2;

    this.add
      .text(cx, 110, 'CARB QUEST', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '64px',
        color: '#ffd166',
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    this.add
      .text(cx, 175, 'Scout the meal. Trust the Spellulator. Read the curve.', {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '20px',
        color: '#9fb4ff',
      })
      .setOrigin(0.5);

    const best = Number(localStorage.getItem(BEST_XP_KEY) ?? 0);
    if (best > 0) {
      this.add
        .text(cx, 220, `Best quest score: ${best} XP`, {
          fontFamily: 'Trebuchet MS, sans-serif',
          fontSize: '18px',
          color: '#7ee787',
        })
        .setOrigin(0.5);
    }

    this.makeButton(310, '⚔️  START QUEST', () => this.scene.start(QuestScene.key));
    this.makeButton(390, '📈  Ride the Line  (unlocks later)', () =>
      this.scene.start(LineRiderScene.key),
    );

    this.add
      .text(
        cx,
        GAME_HEIGHT - 40,
        'A game about predicting your glucose curve — not about perfect numbers. Your body is not a game you can lose.',
        {
          fontFamily: 'Trebuchet MS, sans-serif',
          fontSize: '14px',
          color: '#5a6a99',
        },
      )
      .setOrigin(0.5);
  }

  private makeButton(y: number, label: string, onClick: () => void): void {
    const w = 460;
    const h = 56;
    const x = GAME_WIDTH / 2 - w / 2;
    const bg = this.add
      .graphics()
      .fillStyle(0x273052, 1)
      .fillRoundedRect(x, y, w, h, 12);
    const txt = this.add
      .text(GAME_WIDTH / 2, y + h / 2, label, {
        fontFamily: 'Trebuchet MS, sans-serif',
        fontSize: '22px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
    // Zone origin is (0.5, 0.5): center it so the hit area matches the drawn button.
    const zone = this.add
      .zone(x + w / 2, y + h / 2, w, h)
      .setInteractive({ useHandCursor: true });
    zone.on('pointerover', () => bg.clear().fillStyle(0x3a4a7e, 1).fillRoundedRect(x, y, w, h, 12));
    zone.on('pointerout', () => bg.clear().fillStyle(0x273052, 1).fillRoundedRect(x, y, w, h, 12));
    zone.on('pointerdown', onClick);
    void txt;
  }
}
